__turbopack_context__.v({
  "content": "i3csjW_content",
  "contentWrapper": "i3csjW_contentWrapper",
  "emptyStateDescription": "i3csjW_emptyStateDescription",
  "emptyStateTitle": "i3csjW_emptyStateTitle",
  "emptyStateWrapper": "i3csjW_emptyStateWrapper",
  "header": "i3csjW_header",
  "listingWrapper": "i3csjW_listingWrapper",
  "loaderWrapper": "i3csjW_loaderWrapper",
  "productsListWrapper": "i3csjW_productsListWrapper",
  "sortingInputWrapper": "i3csjW_sortingInputWrapper",
  "sortingLabel": "i3csjW_sortingLabel",
  "title": "i3csjW_title",
  "wrapper": "i3csjW_wrapper",
});
